// Copyright 2018 Sorama B.V.

import { autoinject, transient } from "aurelia-framework";
import { INotificationService, NotificationUrgency } from "services/Notification/INotificationService";

@autoinject
@transient()
export class NotificationModule {
    constructor(protected readonly notificationService: INotificationService) {}

    //#endregion

    private dismissAll(): void {
        for (const notification of this.notificationService.notifications.map((x) => x)) {
            notification.dispose();
        }
    }

    //#region helpers

    private urgencyToClass(urgency: NotificationUrgency): string {
        switch (urgency) {
            case NotificationUrgency.Info:
                return "info";
            case NotificationUrgency.Warning:
                return "warning";
            case NotificationUrgency.Error:
                return "warning";
        }
    }

    private urgencyToIcon(urgency: NotificationUrgency): string {
        switch (urgency) {
            case NotificationUrgency.Info:
                return "fas fa-info-circle";
            case NotificationUrgency.Warning:
                return "fas fa-exclamation-triangle";
            case NotificationUrgency.Error:
                return "fas fa-exclamation-triangle";
        }
    }

    //#endregion
}
